// Please, do not create analytics events here
// Use the protobuf event repository instead
// packages/core/src/protos/events/so5/web/events.ts
// packages/core/src/protos/events/so5/shared/events.ts
// We will slowly migrate all self-defined events to the protobuf repository

import type { Sport as SportType } from '#src/__generated__/globalTypes.ts';

export const socialShareEventName = {
  SHARE_BLOG_POST: 'Share Blog Post',
  SHARE_REFERRAL: 'Share Referral Link',
  SHARE_MANAGER_PROFILE: 'Share Manager Profile',
  SHARE_GALLERY: 'Share Gallery',
  SHARE_CARD: 'Share Card',
  SHARE_DUO_MISSION: 'Share Duo Mission',
  SHARE_WATCHLIST: 'Share Watchlist',
  SHARE_INVITE_FRIENDS_SERIES: 'Share Invite Friends Series',
  SHARE_SQUAD_INVITE: 'Share Squad Invite',
} as const;

export type SocialShareEventName =
  (typeof socialShareEventName)[keyof typeof socialShareEventName];

export const socialShareEventContext = {
  BLOG: 'Blog',
  REFERRAL_PROGRAM: 'referral_program',
  MANAGER_PROFILE: 'Manager Profile',
  CARD_PAGE: 'Card Page',
  MISSIONS_PAGE: 'Missions Page',
  WATCHLIST_PAGE: 'Watchlist Page',
  SERIES_INVITE_FRIENDS: 'Series Invite Friends',
  SQUAD: 'Squad',
} as const;

const FOOTBALL = 'football';

export type SocialShareEventContext =
  (typeof socialShareEventContext)[keyof typeof socialShareEventContext];

export const shareByCopyLinkEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'copy_link',
    context,
  },
});

export const shareByImageEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'image',
    context,
  },
});

export const shareOnTwitterEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'twitter',
    context,
  },
});

export const shareOnFacebookEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'facebook',
    context,
  },
});

export const shareWithShareSheetEvent = (
  name: SocialShareEventName,
  context: SocialShareEventContext,
  sport?: SportType
) => ({
  name,
  properties: {
    sport: sport ?? FOOTBALL,
    target: 'share_sheet',
    context,
  },
});
